import Loadable from '../../../../components/loadable';
import prerenderedLoadable from '../../../../components/prerender';

const Page = Loadable(() =>
  import(/* webpackChunkName: "business-products-app-listing" */ './index')
);

export default prerenderedLoadable(Page);
